import { useQuery } from '@tanstack/react-query';
import { getIpaInspectionAssessment } from '../services/IpaAssessmentService';
import { iimReviewKeys } from './queryKeys';
// Poll every 15s when the assessment is absent (null/404) or still processing,
// so the card appears automatically once peer synthesis completes after any run.
// Polling stops once the record is present and status is complete or failed.
const POLL_INTERVAL_MS = 15000;
function shouldPoll(data) {
    if (data === undefined)
        return true; // not yet fetched
    if (data === null)
        return false; // API confirmed no record — stop polling
    return data.status === 'pending' || data.status === 'processing';
}
export function useIpaInspectionAssessment(inspectionId) {
    return useQuery({
        queryKey: iimReviewKeys.inspectionAssessment(inspectionId),
        queryFn: () => getIpaInspectionAssessment(inspectionId),
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        // IP-13870 / IP-13835: poll until peer synthesis finishes writing the record.
        // When assessment is null (no record yet — Tech Optional / Office First runs)
        // or still in-progress, re-check every 15 s so the card appears automatically.
        refetchInterval: (data) => (shouldPoll(data) ? POLL_INTERVAL_MS : false),
        refetchIntervalInBackground: false
    });
}
